import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export const onboardingTerms = (
  <React.Fragment>
    <Box sx={{ textAlign: 'left' }}>
        <Typography variant='h4' sx={{mb: 2}}>
            Onboarding Fees
        </Typography>
        <Typography>
        An onboarding fee is a one-time cost that covers the initial setup and training required to help new customers get the most out of our platform. This fee typically includes services such as account configuration, data migration, custom integrations, and hands-on training sessions with our customer success team.
        </Typography>
        <Typography sx={{mt:2}}>
        The goal of the onboarding process is to ensure a smooth transition into using our software and to accelerate time-to-value by getting your team up and running quickly and confidently. Think of it as an investment in your long-term success with our product.
        </Typography>
    </Box>
  </React.Fragment>
);
